







import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component<InfoToolTip>({
  components: {
    VPopover
  },
  props: {
    content: String
  },
  directives: {
    VTooltip,
    VClosePopover
  }
})

export default class InfoToolTip extends Vue {
  content: string | undefined
}
